export default __webpack_public_path__ + "static/media/icon-clock.67c21d24.svg";